import { render } from "./VehicleCardComponent.vue?vue&type=template&id=5dd8b474&ts=true"
import script from "./VehicleCardComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleCardComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__